import { isServer } from "@/lib/commonService";
import { HttpMethods } from "../configUtils";
import {
    formatHTTPGetUrl,
    getPreUrlByApiTag,
} from "./replaceUrlBydiffrentFetch";

/**
 *
 * java接口相关的http请求封装
 *
 * url：路径
 * params：参数
 *
 */
enum ErrorCode {
    Success = 200,
}

async function handleErrors(response: Response): Promise<any> {
    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
    }

    const responseData = await response.json();

    // web项目的规则，可能没有返回结果
    if (responseData.code === ErrorCode.Success) {
        return responseData.data;
    } else {
        return responseData.message;
    }
}

class HandleJavaCommonFetch {
    static async request(
        url: string,
        method: HttpMethods,
        params: { [key: string]: any } = {},
        options: RequestInit = {},
    ): Promise<any> {
        let req_url: any = getPreUrlByApiTag(url, "api/javaCommon/");

        options.method = method;
        options.headers = {
            "Content-Type": "application/json",
            ...options.headers,
        };

        if (method === HttpMethods.GET) {
            req_url = formatHTTPGetUrl(req_url, params);
        } else {
            options.body = JSON.stringify(params);
        }

        try {
            const response = await fetch(req_url, options);

            return handleErrors(response);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }

    static async get(
        url: string,
        params?: { [key: string]: any },
        options?: RequestInit,
    ): Promise<any> {
        return HandleJavaCommonFetch.request(
            url,
            HttpMethods.GET,
            params,
            options,
        );
    }

    static async post(
        url: string,
        params?: { [key: string]: any },
        options?: RequestInit,
    ): Promise<any> {
        return HandleJavaCommonFetch.request(
            url,
            HttpMethods.POST,
            params,
            options,
        );
    }

    static async patch(
        url: string,
        params?: { [key: string]: any },
        options?: RequestInit,
    ): Promise<any> {
        return HandleJavaCommonFetch.request(
            url,
            HttpMethods.PATCH,
            params,
            options,
        );
    }
    static async put(
        url: string,
        params?: { [key: string]: any },
        options?: RequestInit,
    ): Promise<any> {
        return HandleJavaCommonFetch.request(
            url,
            HttpMethods.PUT,
            params,
            options,
        );
    }
    static async delete(
        url: string,
        params?: { [key: string]: any },
        options?: RequestInit,
    ): Promise<any> {
        return HandleJavaCommonFetch.request(
            url,
            HttpMethods.DELETE,
            params,
            options,
        );
    }
}

export default HandleJavaCommonFetch;
